import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProgressBarComponent} from './progress-bar';
import {IonicModule} from '@ionic/angular';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {ConfigService} from '../../../core/services/config.service';
import {createTranslateLoader} from '../../utilities/createTranslateLoader';
import {ThemeService} from '../../../core/services/theme.service';

@NgModule({
    declarations: [ProgressBarComponent],
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient, ConfigService, ThemeService]
            }
        })
    ]
})
export class ProgressBarModule {
}
